import { type ReactNode } from "react";
import cn from "classnames";
import { Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { isDev } from "~/utils/isDev";

import styles from "./DevActions.module.scss";

interface Props {
  children: ReactNode;
  allowPartner?: boolean;
  className?: string;
}

export const DevActions = ({ children, className }: Props) => {
  if (!isDev || import.meta.env.VITE_APP_ENV === "preproduction") {
    return null;
  }
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.dropdown}>
        <button className={styles.dropbtn}>
          <Space>
            Действия в дев режиме
            <DownOutlined />
          </Space>
        </button>
        <div className={styles.dropdownContent}>{children}</div>
      </div>
    </div>
  );
};
